import { defineStore } from 'pinia';
import usersAPI from '../apis/users';

// eslint-disable-next-line
export const useDetailStore = defineStore({
  id: 'detail',
  state: () => ({
    currentUser: {
      id: -1,
      account: '',
      name: '',
      view: '',
      execute: '',
      role: '',
    },
    token: '',
    isAuthenticated: false,
    detail: {},
    userId: '',
    datas: [],
    actionRunNumber: 0,
    radarDetail: {},
    isShowReport: false,
    managementLLMTestExpanded: true,
    menuItems: [
      { name: '裝置管理', redirect: '/device-management' },
      { name: '題庫管理', redirect: '/question-bank' },
      { name: '', redirect: '' },
      { name: '', redirect: '' },
      { name: '', redirect: '' },
      { name: '', redirect: '' },
    ],
    menuSelectedItem: '國考專科題目',
  }),
  getters: {
    getters: {
      currentUser: (state) => state.currentUser,
      isShowReport: (state) => state.isShowReport,
      managementLLMTestExpanded: (state) => state.managementLLMTestExpanded,
    },
  },
  actions: {
    setCurrentUser(currentUser) {
      this.currentUser = {
        ...this.currentUser,
        // 透過 API 取得的 currentUser
        ...currentUser,
      };

      this.isAuthenticated = true;
      // token 存在 httpOnly cookie 中，前端不需要存取
      // console.log(`setCurrentUser currentUser: ${JSON.stringify(this.currentUser)}`);
    },
    revokeAuthentication() {
      this.currentUser = {};
      this.isAuthenticated = false;
      this.token = '';
      // token 由後端 cookie 管理，登出時後端會清除 cookie
    },
    async fetchCurrentUser() {
      try {
        const { data } = await usersAPI.getCurrentUser();
        console.log(`fetchCurrentUser: ${JSON.stringify(data)}`);
        if (data.status === 'error') {
          throw new Error(data.message);
        }

        const { id, account, role } = data;
        this.setCurrentUser({
          id,
          account,
          role,
        });

        return true;
      } catch (error) {
        console.error(error.message);
        this.revokeAuthentication();
        return false;
      }
    },
    changeIsShowReportStatus() {
      this.isShowReport = !this.isShowReport;
    },
    async setManagementLLMTestExpanded() {
      // this.managementLLMTestExpanded = !this.managementLLMTestExpanded;
    },
    async setManagementLLMTestCollapsed() {
      // this.managementLLMTestExpanded = false;
    },
  },
});
